document.addEventListener('DOMContentLoaded', () => {
	const target = document.getElementById('articleBanner');
	const banner = document.querySelector('.article-banner');

	if (target && banner) {

		// Append banner inside the target
		target.appendChild(banner);
		banner.classList.remove('hidden');


		// Create spacer element if it doesn't already exist
		let spacer = document.getElementById('bannerSpacer');
		if (!spacer) {
			spacer = document.createElement('div');
			spacer.id = 'bannerSpacer';
			target.parentNode.insertBefore(spacer, target.nextSibling);
		}

		// Function to update spacer height
		const updateSpacerHeight = () => {
			spacer.style.height = banner.offsetHeight + 'px';
		};

		// Call initially and on resize
		updateSpacerHeight();
		window.addEventListener('resize', updateSpacerHeight);

		// Optional: Observe if banner height changes dynamically (e.g. font loads)
		const resizeObserver = new ResizeObserver(updateSpacerHeight);
		resizeObserver.observe(banner);
	}
});